export const ZeroSpreadEvent = {
  ZeroSpreadPageView: 'zero_spread_page_view',
  ZeroSpreadSectionView: 'market_zero_spread_section_view',
  ZeroSpreadLearnMoreClick: 'zero_spread_learn_more_click',
  ZeroSpreadTradeCryptoClick: 'zero_spread_trade_crypto_click',
} as const;
